// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-content {
    width: 100%;
    z-index: 1;
}

.header-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row-reverse;
    margin-right: 20px;
    margin-left: 20px;
}

.language-dropdown-container {
    display: flex;
    align-items: center;
}

.globe-icon {
    font-size: 20px;
    margin: -7px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.logo-container {
    display: flex;
}

.language-dropdown {
    padding: 5px;
    font-size: 16px;
    cursor: pointer;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
    text-decoration-line: underline;
    color: #000000;
    border: none;
    background: none;
    -webkit-appearance: none;
}

.logo-container {
    width: 101px;
    height: 71px;
}

.logo {
    width: 101px;
    height: 71px;
}


.title-container {
    position: absolute;
    width: 100%;
    text-align: center;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    display: flex;
    color: #FFFFFF;
    text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
}

.title {
    font-weight: 700;
    font-size: 36px;
    word-break: break-word;
    margin-bottom: 15px;
}


.subtitle {
    font-weight: 700;
    font-size: 24px;
    line-height: 31px;
    text-align: center;
    width: 280px;
}


@media only screen and (min-width: 450px) {
    .title-container {
        text-shadow: none;
    }

    .title {
        font-size: 48px;
        line-height: 63px;
        color: #06A9C9;
    }

    .subtitle {
        font-size: 36px;
        line-height: 47px;
        color: #61C4D8;
        width: 100%;
        margin-top: 0;
    }

    .logo {
        width: 160px;
        height: 100px;
    }
}`, "",{"version":3,"sources":["webpack://./src/AppHeader.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,+BAA+B;IAC/B,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,mBAAmB;AACvB;;;AAGA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;AAChB;;;AAGA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,cAAc;QACd,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;AACJ","sourcesContent":[".header-content {\n    width: 100%;\n    z-index: 1;\n}\n\n.header-top {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-direction: row-reverse;\n    margin-right: 20px;\n    margin-left: 20px;\n}\n\n.language-dropdown-container {\n    display: flex;\n    align-items: center;\n}\n\n.globe-icon {\n    font-size: 20px;\n    margin: -7px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.logo-container {\n    display: flex;\n}\n\n.language-dropdown {\n    padding: 5px;\n    font-size: 16px;\n    cursor: pointer;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n    text-align: center;\n    text-decoration-line: underline;\n    color: #000000;\n    border: none;\n    background: none;\n    -webkit-appearance: none;\n}\n\n.logo-container {\n    width: 101px;\n    height: 71px;\n}\n\n.logo {\n    width: 101px;\n    height: 71px;\n}\n\n\n.title-container {\n    position: absolute;\n    width: 100%;\n    text-align: center;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    display: flex;\n    color: #FFFFFF;\n    text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);\n}\n\n.title {\n    font-weight: 700;\n    font-size: 36px;\n    word-break: break-word;\n    margin-bottom: 15px;\n}\n\n\n.subtitle {\n    font-weight: 700;\n    font-size: 24px;\n    line-height: 31px;\n    text-align: center;\n    width: 280px;\n}\n\n\n@media only screen and (min-width: 450px) {\n    .title-container {\n        text-shadow: none;\n    }\n\n    .title {\n        font-size: 48px;\n        line-height: 63px;\n        color: #06A9C9;\n    }\n\n    .subtitle {\n        font-size: 36px;\n        line-height: 47px;\n        color: #61C4D8;\n        width: 100%;\n        margin-top: 0;\n    }\n\n    .logo {\n        width: 160px;\n        height: 100px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
